import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { oauthApi } from "../../repositories/oauth";
import Button from "../../components/ui/Button";

const OutlookCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const code = searchParams.get("code");
    if (!code) {
      setError("No authorization code found.");
      return;
    }

    oauthApi.OutlookCallback(code)
      .then(() => {
        navigate("/email", { replace: true });
      })
      .catch((err: any) => {
        setError(err?.response?.data?.message || "Failed to complete Outlook authorization.");
      });
  }, [searchParams, navigate]);

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen px-4 bg-neutral-50">
        <div className="w-full max-w-md p-10 text-center bg-white border shadow-sm rounded-xl border-neutral-200">
          <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-danger-100 rounded-full">
            <svg className="w-8 h-8 text-danger-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h1 className="mb-3 text-xl font-semibold tracking-tight text-black">Authorization Failed</h1>
          <p className="mb-8 text-sm text-neutral-600">{error}</p>
          <Button
            onClick={() => navigate("/email")}
          >
            Return to Email
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 bg-neutral-50">
      <div className="w-8 h-8 border-2 rounded-full border-neutral-200 border-t-primary-700 animate-spin" />
      <p className="mt-4 text-sm text-neutral-600">Connecting your Outlook account...</p>
    </div>
  );
};

export default OutlookCallback;
